



















































































































import VueOptions from '@utils/VueOptions'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import DropdownFilter from '@ui/Filters/DropdownFilter'
import SponsorSetSelector from '@ui/Campaign/SponsorSetSelector'
import VenueSelector from '@ui/Venue/VenueSelector'

settings =
  name: 'RecapResourceList'

  vue:
    props: ['recaps', 'bulkActionResultItems', 'listItemActions', 'filtersOverriden', 'infiniteWrapper', 'actions', 'options']

    components: {
      ResourceList,
      LoadingIndicator,
      DropdownFilter,
      SponsorSetSelector,
      VenueSelector,
    }

    data: ->
      pageNumber: 1
      selectedFilters: []
      selectedRecaps: []

      disabledTarget: false
      sort: [{ field: 'created_at', order: 'desc' }]
      q: ''
      target:
        sponsor_set: []
        venues: []
        start_date: []
        due_date: []
        overdue: false
        published: false
        status:
          not_started: false
          started: false
          completed: false

    computed:
      components: ->
        'recap-resource-list-item': () => import('./RecapResourceListItem')

      title: ->
        @options?.title || 'Your Recaps'

      resourceKey: ->
        @options?.resourceKey || 'recaps'

      selectedFilterBrand: ->
        values = [...@target.sponsor_set]
        values

      selectedFilterVenues: ->
        values = [...@target.venues]
        values

      selectedFilterDates: ->
        values = []
        values.push ...@target.start_date if @target.start_date
        values.push ...@target.due_date if @target.due_date
        values

      selectedFilterStatus: ->
        values = Object.entries(@target.status).filter(([key, value]) => !!value).map(([key]) => key)
        values.push @target.overdue if @target.overdue
        values.push @target.published if @target.published
        values

      actionsForBrandSelector: ->
        select: @selectBrand
        unselect: @unselectBrand
        unselectAll: @unselectAllBrand

      actionsForVenuesSelector: ->
        select: @selectVenues
        unselect: @unselectVenues
        unselectAll: @unselectAllVenues

    methods:
      hiInfiniteScroll: (state) ->
        @doInfinityScroll state

      hiSearchChange: ->

      hiClearFilter: ->
        @clearFilter()
        @filterChange()

      hiClearBrandFilter: ->
        @target.sponsor_set = []
        @filterChange()

      hiClearVenuesFilter: ->
        @target.venues = []
        @filterChange()

      hiClearDatesFilter: ->
        @target.start_date = []
        @target.due_date = []
        @filterChange()

      hiClearStatusFilter: ->
        @target.status[key] = false for key of @target.status
        @target.overdue = false
        @target.published = false
        @filterChange()

      hiApplyFilters: ->
        @$refs.infiniteLoading?.stateChanger?.reset()
        @pageNumber = 1
        @doInfinityScroll()

      filterChange: ->
        @pageNumber = 1
        @doInfinityScroll()

      doInfinityScroll: (state) ->
        @actions.fetchResource state, @resourceKey, @targetPayload(), { page: @pageNumber }
        @pageNumber += 1

      targetPayload: ->
        payload =  q: @q, sort: @sort, target: { ...@target }
        payload

      clearFilter: ->
        @target =
          sponsor_set: []
          venues: []
          start_date: []
          due_date: []
          overdue: false
          published: false
          status:
            not_started: false
            started: false
            completed: false
        @selectedFilters = []

      selectBrand: (option) ->
        @target.sponsor_set.push option.data
      unselectBrand: (option) ->
        @target.sponsor_set = @target.sponsor_set.filter((item) -> item.id isnt option.data.id)
      unselectAllBrand: ->
        @target.sponsor_set = []

      selectVenues: (option) ->
        @target.venues.push option.data
      unselectVenues: (option) ->
        @target.venues = @target.venues.filter((item) -> item.id isnt option.data.id)
      unselectAllVenues: ->
        @target.venues = []

export default VueOptions.vue settings
